<template>
  <label :class="[style['text-input-container'], ...otherClasses]">
    <img v-if="icon" :class="style['input-icon']" :src="icon" alt="">
    <select
      :class="style['text-input']"
      @change='updateInput($event.target.value)'
    >
      <option v-for="(option, index) in options" :key="index" :value="option.value" :selected="option.value === value">{{option.text}}</option>
    </select>
  </label>
</template>

<script>
import style from './scss/_text_input.scss'
import { mapClassNameToArray } from 'Utilities'

export default {
  data: () => ({ style }),
  props: {
    value: {
      type: String,
      default: ''
    },
    icon: String,
    className: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: []
    }
  },
  computed: {
    otherClasses () {
      if (!this.className) { return [] }
      return mapClassNameToArray(this.className, style)
    }
  },
  methods: {
    updateInput (value) {
      this.$emit('input', value)
    }
  }
}
</script>
